module.exports = __webpack_public_path__ + "img/1577633928.e4d5ce70.jpg";